import { render, staticRenderFns } from "./myTie.vue?vue&type=template&id=7b073e30&scoped=true&"
import script from "./myTie.vue?vue&type=script&lang=js&"
export * from "./myTie.vue?vue&type=script&lang=js&"
import style0 from "./myTie.vue?vue&type=style&index=0&id=7b073e30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b073e30",
  null
  
)

export default component.exports